import React from "react";
import { Provider, observer } from "mobx-react";
import store from "./src/mobx";
import { ApolloProvider } from "@apollo/client";
import GQLClient from "./src/GQLClient";
import { PaperProvider } from "react-native-paper";
import Navigation from "./src/navigation/Navigation";
import { useCustomFonts } from "./src/utils/fontsLoader";
import OnlyOneModal from "./src/components/OiqiaModal/OnlyOneModal";

import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";

let client = null;

GQLClient.getInstance().then(gqlClient => {
  client = gqlClient.getApolloClientInstance();
  // Utilisez apolloClient ici
});

const App = observer(() => {

  const [fontsLoaded] = useCustomFonts();

  if (!fontsLoaded) {
    return null;
  }

  const theme = {
    myOwnProperty: true,
    colors: {
      primary: "#10632B",//"#E00078",
      secondary: "#EFEFEF",//"#FFF0FA",
      tertiary: "#D2CA0F",
      success: "#1AB84D",
      background: "white",
      onBackground: "#12100B",
      error: "#E00078"
    },
  };

  console.log("app");

  return (
    <ApolloProvider client={client}>
      <PaperProvider theme={theme}>
        <Provider store={store}>
          <SafeAreaProvider>
            <SafeAreaView
              style={{ flex: 1, backgroundColor: theme.colors.primary }}
            >
              <Navigation />
              <OnlyOneModal />
            </SafeAreaView>
          </SafeAreaProvider>
        </Provider>
      </PaperProvider>
    </ApolloProvider >
  );
});

export default App;
